import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { getHasActiveVehicleStatus } from 'selectors'
import { getCompatibilityFilterValue } from '../selectors'
import { getFilterData, getSelectedFilters } from '../../selectors'
import { updateQuery, resetFilters, applyFilter } from '../actions'
import { hideFilterModal } from 'actions/filterModal'
import BrandFilterModal from './BrandFilterModal'

const withBrandFilterModalHandlers = withHandlers({
  handleSubmit: ({ hideFilterModal }) => () =>
    hideFilterModal(),

  handleFilterClear: ({ resetFilters }) => (...args) =>
    resetFilters(...args),

  handleFilterRemove: ({ applyFilter }) => (...args) =>
    applyFilter(...args),

  handleFilterChange: ({ applyFilter }) => (...args) =>
    applyFilter(...args),

  handleCompatibilityChange: ({ updateQuery }) => (...args) =>
    updateQuery(...args)
})

const mapStateToProps = state => ({
  compatibilityFilter: getCompatibilityFilterValue(state),
  filters: getFilterData(state),
  selectedFilters: getSelectedFilters(state),
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

export default compose(
  connect(mapStateToProps, { updateQuery, resetFilters, applyFilter, hideFilterModal }),
  withBrandFilterModalHandlers
)(BrandFilterModal)
